import React from "react";

export default function SharingHubIcon({ color, ...props }: React.SVGProps<any>) {
  return (
    <svg viewBox="0 0 27 27" width={27} height={27} {...props}>
      <path
        fill="none"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.681}
        d="M25.046 3.787l-8.837 20.45c-.646 1.49-2.708 1.615-3.402.227L9.474 17.78a1.784 1.784 0 00-.807-.807l-6.69-3.333c-1.405-.694-1.264-2.756.225-3.402l20.46-8.837a1.792 1.792 0 012.384 2.385z"
      />
    </svg>
  );
}
